__turbopack_context__.v({
  "h2": "RightPanelComponent-module__C7255q__h2",
  "header": "RightPanelComponent-module__C7255q__header",
  "offerApplied": "RightPanelComponent-module__C7255q__offerApplied",
  "offerTag": "RightPanelComponent-module__C7255q__offerTag",
  "personalizeSection": "RightPanelComponent-module__C7255q__personalizeSection",
  "personalizeTitle": "RightPanelComponent-module__C7255q__personalizeTitle",
  "rightPanel": "RightPanelComponent-module__C7255q__rightPanel",
  "titleContainer": "RightPanelComponent-module__C7255q__titleContainer",
  "transparent": "RightPanelComponent-module__C7255q__transparent",
  "zipToFeatureSectionSpacer": "RightPanelComponent-module__C7255q__zipToFeatureSectionSpacer",
});
